export default function formatCents(amount) {
  return (amount * 100).toFixed(0) + '¢'
}
